import { isDevMode } from '@angular/core';
import {
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
import { editorReducer, EditorState } from '../editor/store/editor.reducer';
import { UserData, userReducer} from '../users/store/user.reducer';

export interface BaseState {
  editor: EditorState
  user?: UserData
}

export const reducers: ActionReducerMap<BaseState> = {
  editor: editorReducer,
  user: userReducer
};


export const metaReducers: MetaReducer<BaseState>[] = isDevMode() ? [] : [];
